import base from "./base";
import filteredList from "./filteredList";
import filters from "./filters";
import list from "./list";
import message from "./message";
import groupFilter from "./groupFilter";

export default `
${message}
${list}
${groupFilter}
${filters}
${base}
${filteredList}
`;
